import { css } from "styled-components";
import { BUTTON_BORDER_SIZE } from "../Button.constants.js";
import { DefaultButtonProps } from "../Button.types.js";
import { getColor } from "./getColor.js";

export const borderGradient = ({ color }: Pick<DefaultButtonProps, "color">) => {
    return css`
        background-clip: padding-box;
        border: solid ${BUTTON_BORDER_SIZE} transparent;
        z-index: 0;

        &:before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: ${(props) => props.theme.elevationLevels.under};
            margin: -${BUTTON_BORDER_SIZE};
            border-radius: inherit;
            background: ${(props) => getColor({ color, value: "100", ...props })};
        }
    `;
};
